{
  "version": 1,
  "asset_id": "7ccfb1c0-5247-47f5-ba59-671b334d5ddb",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7ccfb1c0-5247-47f5-ba59-671b334d5ddb/band-tubing-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7ccfb1c0-5247-47f5-ba59-671b334d5ddb/band-tubing-800.jpg",
  "original_filename": "band-tubing-800.jpg",
  "size": 45924,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T00:20:51Z"
}
